import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { buttonVariants } from '@/components/ui/button'
import EventCard from './EventCard'

const PersonalizedEvents = ({
  events,
}: {
  events: wowaudit.EventReference[]
}) => {
  const { t } = useTranslation()

  return (
    <section className='flex flex-col gap-2'>
      <div className='flex items-center justify-between gap-4'>
        <h4 className='text-base font-medium text-foreground mb-0'>
          {t('homepage.your-events-heading')}
        </h4>
        {events.length > 3 ? (
          <Link
            to='/profile/events'
            className={buttonVariants({ variant: 'outline', size: 'xs' })}
          >
            {t('homepage.view-all-events')}
          </Link>
        ) : null}
      </div>

      <div className='grid grid-cols-1 gap-2 sm:grid-cols-3'>
        {events.slice(0, 3).map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </div>
    </section>
  )
}

export default PersonalizedEvents
